<template>
    <Layout>
        <div class="sticky-header">
            <div class="row">
                <div class="col-lg-12 col-sm-12">
                    <h4 class="header-title pb-3">
                        <a @click="$router.push('/ruta-cobros')" class="ml-2 cursor-pointer">
                            <i class="fa fa-arrow-left"></i></a>
                        <span class="ml-3">Rutas de cobros</span>
                    </h4>
                    <div class="card-container m-b-30">
                        <div class="card-body">
                            <div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group text-left">
                                            <label class="mb-1 fw-bold">Usuario asignado</label>
                                            <input type="text" class="form-control" v-model="username">
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group text-left">
                                            <label class="mb-1 fw-bold">Fecha de ruta</label>
                                            <input type="date" class="form-control" v-model="date">
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <h6 class="fw-bold mb-4 mt-4">Ruta de cobro</h6>
                                    <div>
                                        <div class="bootstrapTable">
                                            <div class="row font-weight-bold mb-2">
                                                <div class="col-12 col-sm-1">
                                                    DPI
                                                </div>
                                                <div class="col-12 col-sm-2">
                                                    NIT
                                                </div>
                                                <div class="col-12 col-sm-2">
                                                    Nombre
                                                </div>
                                                <div class="col-12 col-sm-2">
                                                    Dirección
                                                </div>
                                                <div class="col-12 col-sm-2">
                                                    Teléfono
                                                </div>
                                                <div class="col-12 col-sm-3">
                                                    Observaciones
                                                </div>
                                                <div class="col-12 col-sm-2">
                                                </div>
                                            </div>
                                            <div class="row bootstrapTableRow" v-for="item in rutas">
                                                <div class="col-12 col-sm-1">
                                                    {{item.dpi || 'N/D'}}
                                                </div>
                                                <div class="col-12 col-sm-2">
                                                    {{item.nit || 'N/D'}}
                                                </div>
                                                <div class="col-12 col-sm-2">
                                                    {{item.nombre || 'N/D'}}
                                                </div>
                                                <div class="col-12 col-sm-2">
                                                    {{item.direccion || 'N/D'}}
                                                </div>
                                                <div class="col-12 col-sm-2">
                                                    {{item.telefono || 'N/D'}}
                                                </div>
                                                <div class="col-12 col-sm-2">
                                                    {{item.observaciones || 'N/D'}}
                                                </div>
                                                <div class="col-12 col-sm-1 text-center" style="font-size: 1.3em">
                                                    <i class="fa fa-pencil fa-xl cursor-pointer mb-3" @click="item.edit = 1"></i> <br>
                                                    <i class="fa fa-trash fa-xl cursor-pointer text-danger mb-3" @click="eliminarDetalle(item.id)"></i> <br>
                                                    <i class="fa fa-credit-card fa-xl cursor-pointer text-success" @click="goToPay(item)"></i> <br>
                                                </div>
                                                <div class="col-12 mt-3 p-1" v-if="item.edit">
                                                    <div class="bg-white p-2">
                                                        <div class="row m-0">
                                                            <div class="col-12 col-md-6">
                                                                <div class="form-group text-left">
                                                                    <label class="mb-1 text-primary">Nombre</label>
                                                                    <input type="text" class="form-control" v-model="item.nombre">
                                                                </div>
                                                            </div>
                                                            <div class="col-12 col-md-6">
                                                                <div class="form-group text-left">
                                                                    <label class="mb-1 text-primary">Dirección</label>
                                                                    <input type="text" class="form-control" v-model="item.direccion">
                                                                </div>
                                                            </div>
                                                            <div class="col-12 col-md-6">
                                                                <div class="form-group text-left">
                                                                    <label class="mb-1 text-primary">Teléfono</label>
                                                                    <input type="tel" class="form-control" v-model="item.telefono">
                                                                </div>
                                                            </div>
                                                            <div class="col-12 col-md-6">
                                                                <div class="form-group text-left">
                                                                    <label class="mb-1 text-primary">Observaciones</label>
                                                                    <input type="text" class="form-control" v-model="item.observaciones">
                                                                </div>
                                                            </div>
                                                            <div class="col-12">
                                                                <hr>
                                                                <h6 class="font-weight-bold">Transferir</h6>
                                                            </div>
                                                            <div class="col-12 col-md-6">
                                                                <div class="form-group text-left">
                                                                    <label class="mb-1 text-primary">Ingrese el usuario al cual se realizará la transferencia</label>
                                                                    <input type="text" class="form-control" v-model="item.transferir">
                                                                </div>
                                                            </div>
                                                            <div class="col-12 col-md-6">
                                                                <br>
                                                                <button  @click="transferir(item)" type="button" class="btn btn-primary btn-sm">Realizar transferencia</button>
                                                            </div>
                                                            <div class="col-12 text-right pb-3">
                                                                <hr>
                                                                <button  @click="item.edit = 0" type="button" class="btn btn-dark btn-sm">Cerrar edición</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-right d-flex gap-2 flex-wrap justify-content-end">
                                    <button v-if="parseInt(estado) > 0" @click="desactivarRuta" type="button" class="btn btn-danger mr-2 btn__anular">Desactivar ruta</button>
                                    <button @click="saveRuta" type="button" class="btn btn-success btn__guardar">Guardar ruta</button>
                                </div>
                                <div v-if="rutaId > 0 && parseInt(estado) > 0">
                                    <hr>
                                    <h6>Búsqueda para agregar a ruta</h6>
                                    <div class="row">
                                        <div class="col-6">
                                            <br>
                                            <select v-model="typesearch" class="form-control">
                                                <option value="nit" selected>NIT</option>
                                                <option value="dpi">DPI</option>
                                                <option value="requerimiento">Requerimiento</option>
                                                <option value="poliza">Póliza</option>
                                            </select>
                                            <div class="mt-3">
                                                <button @click="busqueda" class="btn btn-primary">Buscar</button>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div v-if="typesearch === 'dpi'">
                                                <span class="">Ingrese el DPI</span>
                                                <input type="text" class="form-control" placeholder="Escriba aquí" v-model="searchValue">
                                            </div>
                                            <div v-if="typesearch === 'nit'">
                                                <span class="">Ingrese el NIT</span>
                                                <input type="text" class="form-control" placeholder="Escriba aquí" v-model="searchValue">
                                            </div>
                                            <div v-if="typesearch === 'poliza'">
                                                <div class="mb-2">
                                                    <span class="">Ingrese el producto</span>
                                                    <input type="text" class="form-control" placeholder="Escriba aquí" v-model="searchExtraUno">
                                                </div>
                                                <div class="mb-2">
                                                    <span>Ingrese afiliada</span>
                                                    <input type="tel" class="form-control" placeholder="Escriba aquí" v-model="searchExtraDos">
                                                </div>
                                                <div>
                                                    <span class="mt-2">Ingrese No.Póliza</span>
                                                    <input type="tel" class="form-control" placeholder="Escriba aquí" v-model="searchValue">
                                                </div>
                                            </div>
                                            <div v-if="typesearch === 'requerimiento'">
                                                <div class="mb-2">
                                                    <span class="">Ingrese la serie</span>
                                                    <input type="text" class="form-control" placeholder="Escriba aquí" v-model="searchExtraUno">
                                                </div>
                                                <div class="mb-1">
                                                    <span class="mt-2">Ingrese No.Requerimiento</span>
                                                    <input type="tel" class="form-control" placeholder="Escriba aquí" v-model="searchValue">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="searchResultContainer">
                                    <div class="searchResult">
                                        <div class="row" v-if="Object.keys(polizas).length > 0">
                                            <div class="col-12" v-if="(typesearch === 'nit' || typesearch === 'dpi')">
                                                <div v-for="poliza in polizas" class="col-12 mb-2 resultItem">
                                                    <div class="font-weight-bold">
                                                        {{ poliza.descripcion_producto }}
                                                    </div>
                                                    <div v-if="poliza.datos_particulares !== '/'" class="font-weight-bold">
                                                        {{ poliza.datos_particulares }}
                                                    </div>
                                                    <div class="mt-1 text-primary">
                                                        {{ poliza.asegurado }}
                                                    </div>
                                                    <div class="mt-2 searchResultBadges">
                                                        <div class="row m-0">
                                                            <div class="col-5">
                                                                <div class="miniInfo">
                                                                    <span>Póliza:</span>
                                                                    <span class="text-secondary">{{ poliza.poliza }}</span>
                                                                </div>
                                                            </div>
                                                            <div class="col-7">
                                                                <div class="miniInfo">
                                                                    <span>NIT:</span> {{ poliza.nit }}
                                                                </div>
                                                            </div>
                                                            <div class="col-5">
                                                                <div class="miniInfo">
                                                                    <span>Producto:</span> {{ poliza.producto }}
                                                                </div>
                                                            </div>
                                                            <div class="col-7">
                                                                <div class="miniInfo">
                                                                    <span>Estado:</span> {{ poliza.estado_poliza }}
                                                                </div>
                                                            </div>
                                                            <div class="col-12">
                                                                <div class="miniInfo">
                                                                    <span>Vigencia:</span> {{ dayjs(poliza.inicio_vigencia).format('DD-MM-YYYY') }} al {{ dayjs(poliza.fin_vigencia).format('DD-MM-YYYY') }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="text-right mt-2">
                                                        <button @click="agregarRuta(poliza.nit, '', poliza.asegurado, '', poliza.telefono)" class="btn btn-primary">
                                                            <i class="fa fa-plus"></i> Agregar a ruta de cobro
                                                        </button>
                                                    </div>
                                                    <!--<div class="text-center mt-2">
                                                        <button @click="$router.push('/requerimientos/' + poliza.llave_poliza + '?poliza=' + poliza.poliza)" class="btn btn-primary">
                                                            <i class="fa fa-eye"></i> Requerimientos
                                                        </button>
                                                    </div>-->
                                                </div>
                                            </div>
                                            <div class="col-12" v-else-if="typesearch === 'requerimiento' || typesearch === 'poliza'">
                                                <div v-if="typeof polizas[0] !== 'undefined'" class="col-12 mb-2 resultItem">
                                                    <div v-if="polizas[0].datos_particulares !== '/'" class="font-weight-bold">
                                                        {{ polizas[0].datos_particulares }}
                                                    </div>
                                                    <div class="mt-1 text-primary">
                                                        {{ polizas[0].asegurado }}
                                                    </div>
                                                    <div class="mt-2 searchResultBadges">
                                                        <div class="row m-0">
                                                            <div class="col-7">
                                                                <div class="miniInfo">
                                                                    <span>Monto: </span>
                                                                    <span class="font-weight-bold"> {{polizas[0].moneda}} {{ Numbro((polizas[0].monto) ? polizas[0].monto : 0).format({ thousandSeparated: true, mantissa: 2 }) }}</span>
                                                                </div>
                                                            </div>
                                                            <div class="col-5">
                                                                <div class="miniInfo">
                                                                    <span>Póliza: </span>
                                                                    <span class="text-secondary">{{ polizas[0].poliza }}</span>
                                                                </div>
                                                            </div>
                                                            <div class="col-7">
                                                                <div class="miniInfo">
                                                                    <span>NIT: </span> {{ polizas[0].nit }}
                                                                </div>
                                                            </div>
                                                            <div class="col-5">
                                                                <div class="miniInfo">
                                                                    <span>Producto: </span> {{ polizas[0].producto }}
                                                                </div>
                                                            </div>
                                                            <div class="col-7">
                                                                <div class="miniInfo">
                                                                    <span>Estado: </span> {{ polizas[0].estado }}
                                                                </div>
                                                            </div>
                                                            <div class="col-5">
                                                                <div class="miniInfo">
                                                                    <span>Pago No. </span> {{polizas[0].numero_pago}}
                                                                </div>
                                                            </div>
                                                            <div class="col-12">
                                                                <div class="miniInfo">
                                                                    <span>Vigencia: </span> {{ dayjs(polizas[0].inicio_vigencia).format('DD-MM-YYYY') }} al {{ dayjs(polizas[0].fin_vigencia).format('DD-MM-YYYY') }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="text-right mt-2">
                                                        <button @click="agregarRuta(polizas[0].nit, polizas[0].dpi, polizas[0].asegurado, polizas[0].direccion, '')" class="btn btn-primary">
                                                            <i class="fa fa-plus"></i> Agregar a ruta de cobro
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="Object.keys(polizas).length === 0" class="text-center text-muted">
                                                No se encontraron pólizas
                                            </div>
                                        </div>
                                        <div v-else class="text-center text-muted">
                                            Debe guardar la ruta para asignar detalle
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <hr>
                                    <h6>Bitácora de ruta</h6>
                                    <ul class="list-group">
                                        <li class="list-group-item" v-for="item in bitacora">
                                            {{ dayjs(item.createdAt).format('DD-MM-YYYY H:M') }} - {{item.descripcion}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>

import Layout from "../../../global/components/Layout";
import API from "src/core/Api";
import Tools from "src/core/Tools";
import Numbro from "numbro";
import dayjs from "dayjs";
import {store} from "src/store";
import Pago from "src/modules/pos/views/Pago";
import InicioPago from "src/modules/pos/views/components/InicioPago";


export default {
    props: {},
    components: {
        Pago,
        //TimelineChart,
        Layout,
        //Toster,
        InicioPago
    },
    data() {
        return {
            rutaId: 0,
            Valid: {},
            rutas: [],
            typesearch: 'dpi',
            searchValue: '',
            searchExtraUno: '',
            searchExtraDos: '',

            polizas: {},

            // ruta
            username: '',
            date: '',
            estado: 0,
            bitacora: {},
        };
    },
    watch: {
        // whenever question changes, this function will run
        descuento: function (monto) {
            this.monto = monto;

            if (parseFloat(this.montoOriginal) > parseFloat(monto)) {
                this.numeroPagos = 1;
                this.numeroDisabled = true;
            }
            else {
                this.numeroDisabled = false;
            }
        }
    },
    mounted() {

        if (this.$route.params.rutaid !== '') {
            this.rutaId = parseInt(this.$route.params.rutaid);
        }

        const self = this;

        this.getDetalleRuta();
    },
    methods: {
        Numbro,
        dayjs,
        getDetalleRuta() {
            const self = this;
            store.dispatch('coreShowLoading');

            API.send('POST', 'ruta/cobro/detalle', {
                    rutaId: self.rutaId,
                },
                function (response) {
                    if (response.status) {
                        self.username = response.data.ruta.asignado;
                        self.date = response.data.ruta.fecha;
                        self.rutas = response.data.detalles;
                        self.estado = response.data.ruta.estado;
                        self.bitacora = response.data.bitacora;
                        //self.searched = true;
                        store.dispatch('coreHideLoading');
                    }
                    else {
                        //self.searched = true;
                        alert(response.msg);
                    }

                },
                function () {
                    //self.searched = true;
                    store.dispatch('coreHideLoading');
                    alert('Error de conexión, por favor intente de nuevo');
                })
        },
        agregarRuta(nit, dpi, nombre, direccion, telefono) {
            const self = this;
            store.dispatch('coreShowLoading');

            API.send('POST', 'ruta/cobro/agregar-a-ruta', {
                    rutaId: self.rutaId,
                    nit: nit,
                    dpi: dpi,
                    nombre: nombre,
                    direccion: direccion,
                    telefono: telefono,
                },
                function (response) {
                    if (response.status) {
                        //self.searched = true;
                        self.getDetalleRuta();
                        store.dispatch('coreHideLoading');
                    }
                    else {
                        //self.searched = true;
                        alert(response.msg);
                    }
                },
                function () {
                    //self.searched = true;
                    store.dispatch('coreHideLoading');
                    alert('Error de conexión, por favor intente de nuevo');
                })
        },
        eliminarDetalle(idDetalle) {
            const self = this;

            if (confirm('¿Está seguro de eliminar?')) {
                store.dispatch('coreShowLoading');

                API.send('POST', 'ruta/cobro/eliminar-detalle', {
                        idDetalle: idDetalle,
                    },
                    function (response) {
                        if (response.status) {
                            //self.searched = true;
                            self.getDetalleRuta();
                            store.dispatch('coreHideLoading');
                        }
                        else {
                            //self.searched = true;
                            alert(response.msg);
                        }
                    },
                    function () {
                        //self.searched = true;
                        store.dispatch('coreHideLoading');
                        alert('Error de conexión, por favor intente de nuevo');
                    })
            }
        },
        saveRuta() {
            const self = this;

            API.send('POST', 'ruta/cobro/save-ruta', {
                    rutaId: self.rutaId,
                    username: self.username,
                    date: self.date,
                    detalle: self.rutas
                },
                function (response) {
                    if (response.status) {
                        const idRuta = parseInt(response.data);
                        store.dispatch('coreHideLoading');
                        if (parseInt(self.rutaId) === 0) {
                            window.location.href = '/ruta-cobros-create/' + idRuta;
                        }
                    }
                    else {
                        //self.searched = true;
                        alert(response.msg);
                    }
                },
                function () {
                    //self.searched = true;
                    store.dispatch('coreHideLoading');
                    alert('Error de conexión, por favor intente de nuevo');
                })
        },
        desactivarRuta() {
            const self = this;

            if (confirm('¿Está seguro que desea desactivar la ruta? esta accion no se puede deshacer')) {
                API.send('POST', 'ruta/cobro/delete-ruta', {
                        rutaId: self.rutaId,
                    },
                    function (response) {
                        if (response.status) {
                            self.getDetalleRuta();
                        }
                        else {
                            //self.searched = true;
                            alert(response.msg);
                        }
                    },
                    function () {
                        //self.searched = true;
                        store.dispatch('coreHideLoading');
                        alert('Error de conexión, por favor intente de nuevo');
                    })
            }

        },
        transferir(item) {
            const self = this;

            if (confirm('¿Está seguro que desea transferir?')) {
                API.send('POST', 'ruta/cobro/transferir', {
                        userToTransfer: item.transferir,
                        rutaDetalleId: item.id,
                    },
                    function (response) {
                        if (response.status) {
                            self.getDetalleRuta();
                        }
                        else {
                            //self.searched = true;
                            alert(response.msg);
                        }
                    },
                    function () {
                        //self.searched = true;
                        store.dispatch('coreHideLoading');
                        alert('Error de conexión, por favor intente de nuevo');
                    })
            }

        },
        busqueda() {

            const self = this;
            let url;

            if (this.typesearch === 'dpi') {
                url = 'consulta/dpi?s=' + self.searchValue;
            }
            else if (this.typesearch === 'nit') {
                url = 'consulta/nit?s=' + self.searchValue;
            }
            else if (this.typesearch === 'requerimiento') {
                this.searchExtraUno = self.searchExtraUno.toString().toUpperCase();
                url = 'consulta/req?s=' + self.searchValue + '&serie=' + self.searchExtraUno;
            }
            else if (this.typesearch === 'poliza') {
                self.searchExtraUno = self.searchExtraUno.toString().toUpperCase();
                if (self.searchExtraDos === '') {
                    self.searchExtraDos = 0;
                }
                url = 'consulta/poliza?s=' + self.searchValue + '&producto=' + self.searchExtraUno+ '&afiliada=' + self.searchExtraDos;
            }

            store.dispatch('coreShowLoading');

            API.send('GET', url, null,
                function (response) {
                    if (response.status) {
                        self.polizas = (typeof response.data === "object") ? response.data : {};

                        //self.searched = true;
                        store.dispatch('coreHideLoading');
                    }
                    else {
                        //self.searched = true;
                        alert(response.msg);
                    }

                },
                function () {
                    //self.searched = true;
                    store.dispatch('coreHideLoading');
                    alert('Error de conexión, por favor intente de nuevo');
                })
        },
        goToPay(item) {

            window.location.href = '/busqueda/nit/' + item.nit;
        }
    },
};
</script>
